export default __webpack_public_path__ + "static/media/Eric-van-Schagen.5833b332.jpeg";